import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../core/services/data.service';
import { ProdCalendar } from '../../shared/models/ProdCalendar/ProdCalendar';
import { NotificationService } from '../../core/services/notification.service';

@Injectable()
export class ProdCalendarService extends DataService<ProdCalendar> {

	constructor(http: HttpClient, notificationService: NotificationService) {
		super(http, notificationService);
		this.controllerName = "prodCalendar";
	}

}